import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#3F5C58",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2E3238",
      contrastText: "#fff",
    },
    background: {
      default: "#f3f3f3",
    },
  },
  typography: {
    fontFamily: "\"Questrial\", Arial, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          fontWeight: 700,
        },
      },
    },
  },
});

export default theme;
